import ImagesIconsTransactionInfoSvg from '@/public/images/icons/transaction/info.svg';
import ImagesIconsTransactionSuccess2Svg from '@/public/images/icons/transaction/success_2.svg';
import ImagesIconsTransactionSuccessSvg from '@/public/images/icons/transaction/success.svg';

export {
  ImagesIconsTransactionInfoSvg,
  ImagesIconsTransactionSuccess2Svg,
  ImagesIconsTransactionSuccessSvg,
};
